// src/common/components/LoadingScreen/LoadingScreen.tsx
import React from "react";
import styles from "./LoadingScreen.module.scss";
import { useTheme } from "../../../common/hooks/useTheme";

export const LoadingScreen: React.FC = () => {
  const { theme } = useTheme();

  

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: process.env.REACT_APP_BACKGROUND || theme.background }}
    >

      {/* <img src="/icons/logo192.png"/> */}
      {/* <div className={styles.loader}>
        <div
          className={styles.spinner}
        />
      </div> */}
    </div>
  );
};
